<template>
  <el-dropdown size="small" trigger="click" @command="handleCommand">
    <span>{{ title }}<i class="el-icon-arrow-down"></i></span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in data"
        :key="item.paramKey + item.paramValue"
        v-text="item.paramValue"
        :command="item"
      ></el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleCommand(c) {
      this.$emit("select", c);
    }
  }
};
</script>

<style lang="scss">
.el-icon-arrow-down {
  font-size: 12px;
  margin-left: 5px;
}
</style>
